import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";


const Thome = () => {
  const { page } = useParams();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);

    // Set loaded to true after a short delay to allow animations to occur
    const timeout = setTimeout(() => {
      setLoaded(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, [page]); // Re-run effect when page changes


  return (
    <div className={`bg-gray-600 ${loaded ? 'slide-in' : ''}`}>
      <h1 className='text-center py-4 text-3xl text-white font-location'>DOROTHY HOME</h1>
      <div className="mx-auto max-w-7xl px-4 py-2 sm:px-6 ">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-2 xl:grid-cols-5 gap-3">
  
        <img src="gallery/thome/thome1.jpg" alt="thome" className={`w-full rounded-md h-auto transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/thome/thome2.jpg" alt="thome" className={`w-full rounded-md h-auto transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/thome/thome3.jpg" alt="thome" className={`w-full rounded-md  h-auto transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/thome/thome4.jpg" alt="thome" className={`w-full rounded-md  h-auto transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/thome/thome5.jpg" alt="thome" className={`w-full rounded-md  h-auto transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/thome/thome6.jpg" alt="thome" className={`w-full rounded-md  h-auto transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/thome/thome7.jpg" alt="thome" className={`w-full rounded-md h-auto transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/thome/thome8.jpg" alt="thome" className={`w-full rounded-md  h-auto transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/thome/thome9.jpg" alt="thome" className={`w-full rounded-md h-auto transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />

      
        </div>
      </div>
    </div>
  );
}

export default Thome;
